export function deleteChildNodes(node) {
  while (node && node.firstChild) {
    node.firstChild.remove();
  }
}
